import React from 'react';

import Reveal from '../ui/Reveal';
import WordReveal from '../ui/WordReveal';

/** Eyebrow, headline and lead, revealed in that order. */
export default function SectionHead({ eyebrow, title, lead, center, className = '' }) {
    return (
        <div className={`section-head${center ? ' section-head--center' : ''} ${className}`.trim()}>
            {eyebrow && (
                <Reveal y={18}>
                    <span className="t-eyebrow t-eyebrow--accent">{eyebrow}</span>
                </Reveal>
            )}

            <WordReveal as="h2" className="t-h2" text={title} />

            {lead && (
                <Reveal delay={0.12}>
                    <p className="t-lead">{lead}</p>
                </Reveal>
            )}
        </div>
    );
}
